import { motion } from "motion/react";
import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
  seconds: number;
  minutes: number;
};
export default function DeathScreenTimer({ seconds, minutes, className }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: "-100%" }}
      animate={{ opacity: 1, translateY: "none" }}
      transition={{ duration: 0.5, type: "spring" }}
      exit={{ opacity: 0, translateY: "-100%" }}
      className={cn("text-[#FF4E4E] text-[1.875rem] font-extrabold tabular-nums", className)}
    >
      {String(minutes).length === 1 ? `0${minutes}` : minutes}:
      {String(seconds).length === 1 ? `0${seconds}` : seconds}
    </motion.div>
  );
}
